import { ThemeProvider } from "@mui/material";
import { designSystemTheme } from "@qubit/autoparts";
import type { ReactNode } from "react";

import { useFlag } from "~/config/flags";

export function ASDSThemeProvider({ children }: { children: ReactNode }) {
  const { enableColorChanges } = useFlag();
  return enableColorChanges ? (
    <ThemeProvider theme={designSystemTheme}>{children}</ThemeProvider>
  ) : (
    <>{children}</>
  );
}
